'use strict';

import TopMenu from './components/TopMenu.vue';

export default class {

    constructor() {
        // Register component globaly
        Vue.component('top-menu', TopMenu);

    }
}